// @ts-nocheck

import { useEffect, useState } from "react";
import { format, isFuture } from "date-fns";

import { ptBR } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";

import { cn } from "../lib/utils";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

import useStoreTimToa from "../store/useStoreTimToa";

export function DatePickerEnd() {
  const [date, setDate] = useState<Date>();
  const { setEndDate } = useStoreTimToa((state) => state);

  useEffect(() => {
    setEndDate(date);
  }, [date]);

  const disabledDays = (date: Date) => {
    const disabled = isFuture(date);
    return disabled;
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[280px] justify-start text-left font-normal",
            !date && "text-muted-foreground"
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? (
            format(date, "dd/MM/yyyy", { locale: ptBR })
          ) : (
            <span>Selecione uma data</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={setDate}
          initialFocus
          locale={ptBR}
          disabled={disabledDays}
        />
      </PopoverContent>
    </Popover>
  );
}
